// EmailIdentity — an email address split in two (User management, User access): the person's
// name stands out, @company recedes. Styled by .um-email* in UserManagement.css.
import React from 'react';

export default function EmailIdentity({ email }) {
  const at = email.lastIndexOf('@');
  if (at <= 0) return <span className="um-email" title={email}>{email}</span>;
  return (
    <span className="um-email" title={email}>
      <span className="um-email__name">{email.slice(0, at)}</span>
      <wbr />
      <span className="um-email__domain">{email.slice(at)}</span>
    </span>
  );
}
